import { Component, Input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonStammMasterDetailEntryMeta } from '../../../../core/personstamm-api';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { DayMonthYearDatePipe } from '../../../../shared/pipes/simple/dayMonthYearDate.pipe';
import { FormatAhvPipe } from '../../../../shared/pipes/format/format-ahv.pipe';
import { FormatUidPipe } from '../../../../shared/pipes/format/format-uid.pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-personstamm-natuerliche-person',
  templateUrl: './personstamm-natuerliche-person.component.html',
  styleUrls: ['./personstamm-natuerliche-person.component.scss'],
  imports: [KopfdatenelementComponent, TranslatePipe, DayMonthYearDatePipe, FormatAhvPipe, FormatUidPipe, TranslateNamePipe]
})
export class PersonstammNatuerlichePersonComponent {
  @Input()
  public entry: PersonStammMasterDetailEntryMeta;

  constructor(public translate: TranslateService) {
    keysToTranslate<string>([
      'Personalien',
      'Heimatort',
      'NameDerEltern',
      'NameEhegatte',
      'Geschlecht',
      'Zivilstand',
      'Nationalitaet',
      'Personengruppe',
      'Sprache',
      'Anrede',
      'AHVNummer',
      'AHVVersichertennummer',
      'UidStatus',
      'Gueltig',
      'Adressen',
      'NotAvailable'
    ]);
  }
}
